import React, { Fragment } from 'react';

/* Atoms */
import { Icon } from "js/components/atoms";

/* Context */
import { VehicleOverviewContext } from 'js/context';

/* Components */
import Filter from './Filter';

/* Utilities */
import { trans, transWithFilter } from 'js/utilities';

export default class FilterChoice extends React.Component {
    static contextType = VehicleOverviewContext;

    constructor(props) {
        super(props);

        this.updateFilters = () => { };
    }

    componentDidMount() {
        this.updateFilters = this.context.updateFilters;
    }

    render() {
        const { id, filter, path, multiple = true, } = this.props;

        const loadChoiceIcon = (choiceName) => {
            try {
                return require(`symbols/choice-${choiceName.toLocaleLowerCase().replaceAll(' ', '-')}.svg`).default.url;
            } catch (err) {
                if (err.code === 'MODULE_NOT_FOUND') return;
            }
            return;
        }

        return (
            <div className="row gutters-0">
                {filter.choices.map((choice) => {
                    const choiceIndex = filter.choices.indexOf(choice);
                    const choiceId = `${id}.choices.${choiceIndex}`
                    const choicePath = `${path}.choices.${choiceIndex}`
                    const choiceIcon = loadChoiceIcon(choice.name);

                    return (
                        <Fragment key={choiceId}>
                            <div className="col-12">
                                <div className={`custom-control custom-${multiple ? 'checkbox' : 'radio'}`}>
                                    <input
                                        id={choiceId}
                                        name={`${path}.choices`}
                                        className="custom-control-input"
                                        type={multiple ? 'checkbox' : 'radio'}
                                        checked={choice.active}
                                        onChange={(event) => {
                                            event.persist();
                                            this.updateFilters(`${path}.choices`, (choices) => {
                                                return choices.map((choice, index) => ({
                                                    ...choice,
                                                    active: index === choiceIndex ? event.target.checked : multiple ? choice.active : false,
                                                }))
                                            });
                                        }}
                                    />
                                    <label className="custom-control-label d-flex align-items-center gap-2" htmlFor={choiceId}>
                                        {choiceIcon ? (
                                            <Icon url={choiceIcon} size={32} />
                                        ) : null}
                                        {trans(`sulu.content_block.vehicle_overview.filter.key.${filter.filterKey}.prefix`, {}, '')}

                                        {transWithFilter(`sulu.content_block.vehicle_overview.filter.choices.${choice.name}`, {}, choice.name)}

                                        {trans(`sulu.content_block.vehicle_overview.filter.key.${filter.filterKey}.suffix`, {}, '')}
                                    </label>
                                </div>
                            </div>
                            {choice.active && choice.filters.length > 0 && (
                                <div className="col-12">
                                    <Filter
                                        className="filter--nested"
                                        id={choiceId}
                                        path={`${choicePath}`}
                                        filters={choice.filters}
                                    />
                                </div>
                            )}
                        </Fragment>
                    );
                })}
            </div>
        );
    }
}
